<script setup lang="ts">
defineProps<{
  to: any;
}>();
</script>

<template>
  <li>
    <NuxtLink
      :to="to"
      class="flex items-center border-b-[3px] border-transparent bg-transparent p-3 text-sm font-semibold uppercase text-gray-400 hover:border-brand-primary hover:text-black">
      <slot></slot>
    </NuxtLink>
  </li>
</template>

<style scoped></style>